import { render, staticRenderFns } from "./batchAllocationControl.vue?vue&type=template&id=75f32510&scoped=true&"
import script from "./batchAllocationControl.vue?vue&type=script&lang=js&"
export * from "./batchAllocationControl.vue?vue&type=script&lang=js&"
import style0 from "./batchAllocationControl.vue?vue&type=style&index=0&id=75f32510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f32510",
  null
  
)

component.options.__file = "batchAllocationControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VExpansionPanel,
  VExpansionPanelContent,
  VFlex,
  VForm,
  VIcon,
  VSpacer,
  VSwitch,
  VTextField,
})
